<template>
    <div id="login-page" class="d-flex align-items-center h-100">
        <landing-page></landing-page>
        <section class="login-section right order-first order-md-last">
            <div class="login-form">
                <h2 class="form-title">{{ __("title", this.translations.resetPasswordPage) }}</h2>
                <h3 class="form-description">{{ __("description", this.translations.resetPasswordPage) }}</h3>
                <set-password :buttonName="this.translations.resetPasswordPage.button"
                              passwordThemeColor="white-li"
                              @submit="resetPassword" :status="status"></set-password>
                <button class="form-button" disabled v-if="status === 'loading'"><i
                        class="fas fa-circle-notch fa-spin"></i>{{ __('loading', this.translations.global) }}
                </button>
            </div>
            <div class="languages bottom-section">
                <button :class="[ 'language-btn', { 'active': isCurrentLanguage('en') } ]" @click="setLanguage('en')">
                    EN
                </button>
                <button :class="[ 'language-btn', { 'active': isCurrentLanguage('ar') } ]" @click="setLanguage('ar')">
                    عر
                </button>
            </div>
        </section>
    </div>
</template>

<script>
    import LandingPage from "../components/LandingPage";
    import SetPassword from "../components/SetPassword";
    import Auth from "../services/AuthService";

    export default {
        name: "reset-password-page",
        components: {
            SetPassword,
            LandingPage,
        },
        data() {
            return {
                status: "ready"
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                if (!this.$route.query.token || !this.$route.query.id) {
                    this.$router.push('login');
                }
            },
            async resetPassword(password) {
                this.status = "loading";
                try {
                    Auth.resetPassword(this.$route.query.token, this.$route.query.id, password)
                        .then(() => {
                            this.$router.push('login');
                        })
                        .catch(() => this.errors.push('Oouupss!! Sorry something went wrong, try again in a few minutes!'));
                } catch (e) {
                    console.log(e);
                } finally {
                    this.status = "ready";
                }
            },
            setLanguage(language) {
                this.$store.dispatch("setLanguage", language);
            },
            isCurrentLanguage(language) {
                return this.$store.getters.appLanguage === language;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #login-page {
        overflow: auto;

        .login-section {
            display: flex;
            align-items: center;
            flex-direction: row;
            height: 100%;

            .centered {
                display: flex !important;
                justify-content: center !important;
            }

            .bottom-section {
                justify-content: center;
                position: absolute;
                width: 100%;
                bottom: 10px;
            }

            &.left {
                position: relative;

                .main-title {
                    font-family: $raleway;
                    color: $darkest-gray;
                    font-weight: 900;
                    line-height: 1.1;
                    text-transform: uppercase;
                    font-size: 40px;

                    .line {
                        display: flex;
                        align-items: center;
                    }
                }
            }

            &.right {
                position: relative;
                background-color: $primary;

                .login-form {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    width: 100%;

                    .form-title {
                        width: 100%;
                        margin: 0 0 10px 0;
                        font-size: 22px;
                        font-weight: 700;
                        font-family: $raleway;
                        color: $white;
                        line-height: 1;
                        text-align: left;
                    }

                    .form-description {
                        width: 100%;
                        font-family: $roboto;
                        font-size: 16px;
                        line-height: 1.4;
                        color: $light-gray;
                        text-align: left;

                        a {
                            color: $light-gray !important;
                            text-decoration: underline;
                            cursor: pointer;

                            &:hover {
                                text-decoration: none;
                            }
                        }
                    }

                    .form-error {
                        width: 100%;
                        color: $white;
                        font-family: $lato;
                        font-weight: 400;
                        font-size: 15px;
                        color: $orange;

                        ul {
                            margin: 0;
                        }

                        i {
                            margin: 0px 7px 0px 0px;
                        }
                    }

                    .form-field {
                        width: 100%;
                    }

                    .form-button {
                        display: block;
                        width: 100%;
                        padding: 7px 0;
                        font-weight: 700;
                        font-family: $raleway;
                        border: 2px solid $white !important;
                        border-radius: 25px;
                        color: $primary;
                        background-color: $white;

                        i {
                            margin: 0 10px 0 0;
                        }

                        &:hover {
                            color: $white;
                            background-color: transparent;
                        }

                        &:disabled {
                            border: 2px solid $light-gray !important;
                            background-color: $light-gray;
                            color: $dark-gray;

                            &:hover {
                                background-color: $light-gray;
                            }
                        }
                    }
                }

                .languages {
                    display: flex;
                    align-items: center;

                    .language-btn {
                        margin: 0 5px 0 0;
                        padding: 1px 8px;
                        font-size: 12px;
                        font-weight: 700;
                        font-family: $raleway;
                        text-transform: uppercase;
                        color: $white;
                        background: none;
                        @include removeBootstrapOutline;
                        border: 2px solid transparent !important;
                        border-radius: 3px;
                        cursor: pointer;
                        @include fastestTransition;

                        &:hover, &.active {
                            border: 2px solid $white !important
                        }

                        &:last-child {
                            margin: 0;
                        }
                    }
                }
            }
        }
    }

    .dark {
        #login-page {
            .login-section {
                &.left {
                    .main-title {
                        color: $white;
                    }
                }

                &.right {
                    background-color: $extra-darker-gray;

                    .login-form {
                        .form-error {
                            color: $light-red;
                        }

                        .form-button {
                            color: $extra-darker-gray;

                            &:hover {
                                color: $white;
                            }

                            &:disabled {
                                color: $gray;
                                border: 2px solid $extra-dark-gray !important;
                                background-color: $extra-dark-gray;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: $breakpoint-md) {
        #login-page {
            flex-direction: column;

            .login-section {
                height: auto;
                flex-direction: column;

                .centered {
                    display: block;
                }

                .bottom-section {
                    position: static;
                    transform: translate(0);
                    padding: 10px 0;
                }

                &.left {
                    width: 100%;

                    .main-title {
                        font-size: 22px;

                        .line {
                            display: inline;
                        }
                    }
                }

                &.right {
                    width: 100%;

                    .login-form {
                        padding: 30px 20px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $breakpoint-md) {
        #login-page {
            .login-section {
                .centered {
                    display: block;
                }

                &.left {
                    width: 50%;

                    .main-title {
                        font-size: 30px;
                    }
                }

                &.right {
                    width: 50%;

                    .login-form {
                        padding: 0 25px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $breakpoint-lg) {
        #login-page {
            .login-section {
                &.left {
                    width: 70%;
                }

                &.right {
                    width: 30%;

                    .login-form {
                        padding: 0 35px;
                    }
                }
            }
        }
    }
</style>
